import type { Release } from '../releases';

export default {
  id: '2026-11-03-route-skip-absent',
  at: '2026-11-04T09:35:00Z',
  title: 'Согласование договора не стоит, когда согласующие в отпуске',
  modules: ['contracts'],
  items: [
    'Если все, кто может согласовать шаг маршрута договора или допсоглашения, отсутствуют, а их заместители решать о деньгах не могут, шаг отмечается «пропущен» с причиной и маршрут идёт дальше. Шаги юриста и службы безопасности не пропускаются — их решает владелец компании; договор, согласованный с пропуском, попадает в «Требует внимания».',
    'Подписать договор поставки, не дождавшись согласований, может только подписант; сотрудник, который лишь оформляет документы договора, — нет.',
  ],
  why: 'Договор зависал на шаге, решить который было некому, пока согласующий в отпуске; а подписать его в обход маршрута мог сотрудник без права подписи.',
  link: '/contracts',
} satisfies Release;
